import React from 'react';
import DashboardSourceCodeToggle from './DashboardSourceCodeToggle';

export interface DashboardSourceCodeToggleButtonProps {
  toggle: () => void;
}

export const DashboardSourceCodeToggleButton: React.FC<DashboardSourceCodeToggleButtonProps> = ({ toggle }) => (
  <button className="my-4 mx-auto" onClick={toggle}>
    <DashboardSourceCodeToggle />
  </button>
);
